module.exports = __webpack_public_path__ + "static/media/ThaparUniversity_1.c7f8f002.jpg";